
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class JuliaSetEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const iterations = Math.floor(12 * (config.parallaxComplexity || 1.0));
        const curTime = time * 0.3 * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            ctx.save();
            const baseScale = 250 * scale * (1 / (layerIndex + 1));
            for (let i = 0; i < iterations; i++) {
                const s = baseScale * Math.pow(0.85, i);
                const rot = curTime + i * 0.5;
                
                ctx.save();
                ctx.rotate(rot);
                ctx.beginPath();
                ctx.rect(-s, -s, s * 2, s * 2);
                ctx.stroke();
                ctx.restore();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
